import React, {FC} from "react";

interface Props {
    text: string;
    actual: any;
    val: any;
    set(val: any):any;
}

export const RadioComponent : FC<Props> = (props) => {
    return <>
        <input
        type="radio"
        value={props.val}
        checked={props.actual === props.val}
        onChange={() => props.set(props.val)}
    />{props.text}
    </>
}